<template>
	<div v-if="viewLoaded" class="offer-read-only">
		<div v-if="!offerData.sendDate" class="d-none print-only"><h1>(Wydruk próbny!)</h1></div>

		<h3 v-if="currentModuleForPrint" class="text-xs-center">
			M {{currentModuleForPrint}}
			<span v-if="!offerData.sendDate" class="d-none print-only"><h1>(Wydruk próbny!)</h1></span>
		</h3>
		<offer-name
			:readonly="true"
			v-model="offerData.title"
		></offer-name>

		<ContestOfferSummaryHeader :offer-data="offerData" :contest-configuration="contestConfiguration"/>
		<BidderNameReadOnlyView :view-data="offerData"/>

		<div class="read-only-offer-modules mt-3">
			<div v-for="i in (numberOfModules !== 0 ? numberOfModules : 1)" :key="i"
				:class="resolvePrintClassFormModule(i)">
				<contest-offer-activities-description
					class="d-none print-only mt-2 mb-2"
					:readonly="true"
					:actions="timetableActions(i)"
					:show-print-info="!offerData.sendDate"
					:remove-page-break="true"
					:contestId="contestId"
				></contest-offer-activities-description>
			</div>
		</div>
		<div v-if="!offerData.sendDate"><h1>Wydruk próbny !</h1></div>
	</div>
</template>

<script>
	import OfferName from "./components/OfferName";
	import ContestOfferSummaryHeader from "./components/ContestOfferReadOnlyHeader";
	import ContestOfferActivitiesDescription from "./components/ContestOfferActivitiesDescription";
	import {genericFormUtil} from "../../../utils/genericFormUtil";
	import {Api} from "../../../api";
	import BidderNameReadOnlyView from "./components/ReadOnlyComponents/BidderNameReadOnlyView";

	export default {
		name: "ContestReadOnlyOfferActivitiesDescriptionView",
		components: {BidderNameReadOnlyView, ContestOfferActivitiesDescription, ContestOfferSummaryHeader, OfferName},

		created () {
			this.loadData();
		},

		data () {
			return {
				contestConfiguration: {
					numberOfModules: 0,
					moduleSchema: null,
					persistentSchema: null,
					firstPossibleOfferDate: "",
					lastPossibleOfferDate: "",
				},

				// tutaj pakujemy dane oferty
				offerData: {
					step: 1,
					id: this.$route.params.offerId,
					title: "",
					sendDate: this.$route.params.sendDate,
					englishTitle: "",
					legalForm: "",
					polishName: "",
					otherBiddersId: [],
					prioritiesData: {
						selected: [],
						extraCountries: [],
					},
					stepsConstantData: [],
					financesData: {
						countriesFundings: [],
						totalFundings: "",
					},
					dacCodes: [],
					moduleGenericModel: undefined,
					genericModel: undefined,
					mutualOffer: false,
				},

				contestConfigurationLoaded: false,
				offerDataLoaded: false,
				currentModuleForPrint: parseInt(this.$route.params.module),
			};
		},

		computed: {
			viewLoaded () {
				return this.offerDataLoaded && this.contestConfigurationLoaded;
			},

			numberOfModules () {
				return this.contestConfiguration.numberOfModules;
			},
			contestId() {
				return this.$route.params.id;
			},
		},

		methods: {
			timetableActions(moduleNumber) {
				const actions = JSON.parse(JSON.stringify(this.offerData.stepsConstantData[moduleNumber -1].actionsData));
				return actions.sort((a, b) => a.serialNumber - b.serialNumber);
			},

			async loadData () {
				await Api.syncGet(this, "/public-contest/offer-configuration?offerId=".concat(this.offerData.id), response => {
						this.initializeContestConfiguration(response);
						// inicjalizuje schematy generycznego formularza
						this.initializeGenericSchemas(response);
						// inicjalizujemy wartosci generycznego formularza w ofercie
						this.contestConfigurationLoaded = true;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji oferty!", errorResponse),
				);
				// Pobranie danych oferty
				let path;
				if (this.$route.params.version) {
					path = "/offer/data-version?offerId=".concat(this.offerData.id).concat("&version=".concat(this.$route.params.version));
				} else {
					path = "/offer/data-readonly?offerId=".concat(this.offerData.id);
				}
				await Api.syncGet(
					this,
					path,
					response => {
						for (let field in response) {
							this.$set(this.offerData, field, response[field]);
						}
						this.contestConfiguration.numberOfModules = this.resolveNumberOfModules(response);
						this.initializeGenericModel(response);
						this.offerDataLoaded = true;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać oferty!", errorResponse),
				);
			},

			initializeContestConfiguration (response) {
				this.contestConfiguration.moduleSchema = genericFormUtil.decodeSchema(response.moduleSchema);
				this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.persistentSchema);
				this.contestConfiguration.firstPossibleOfferDate = response.firstPossibleOfferDate;
				this.contestConfiguration.lastPossibleOfferDate = response.lastPossibleOfferDate;
				this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
				this.contestConfiguration.volunteersRequired = response.volunteersRequired;
				this.contestConfiguration.modulePriceLimit = response.modulePriceLimit;

			},

			initializeGenericModel (response) {
				this.offerData.genericModel = this.getPersistentModel(response);
				this.offerData.moduleGenericModel = this.getModuleModel(response);
			},

			getModuleModel (response) {
				if (this.contestConfiguration.numberOfModules > 0) {
					let map = {};
					for (let i = 1; i <= this.numberOfModules; i++) {
						if (response.moduleGenericModel[i]) {
							map[i] = genericFormUtil.decodeSchema(response.moduleGenericModel[i]);
						} else {
							map[i] = genericFormUtil.buildModelFromSchema(this.contestConfiguration.moduleSchema);
						}
					}
					return map;
				}
				return null;
			},

			initializeGenericSchemas (response) {
				this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
				this.contestConfiguration.moduleSchema = this.getModuleSchema(response);
			},

			getPersistentModel (response) {
				if (response.persistentGenericModel) {
					return genericFormUtil.decodeSchema(response.persistentGenericModel);
				}
				return genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
			},

			getPersistentSchema (response) {
				return genericFormUtil.decodeSchema(response.persistentSchema);
			},

			getModuleSchema (response) {
				if (response.moduleSchema) {
					return genericFormUtil.decodeSchema(response.moduleSchema);
				}
				return null;
			},

			resolveNumberOfModules (response) {
				// zwraca 0 w przypadku gdy nie jest to oferta modulowa, może też być 1 modul, wtedy zwraca 1 oraz n, wtedy n.
				return Object.keys(response.moduleGenericModel).length;
			},

			resolvePrintClassFormModule (moduleNumber) {
				if (!this.$route.params.module) return "";
				if (this.numberOfModules > 1 && this.currentModuleForPrint !== null && this.currentModuleForPrint !== moduleNumber) {
					return "no-print";
				}
			},
		}
	};
</script>

<style scoped>

</style>
